"use client";

import Arrow from "@/src/icons/Arrow";
import { useEffect, useState } from "react";

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 1135);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed right-4 bottom-2 sm:right-6 sm:bottom-[-20px] md:right-3 md:bottom-[-30px] lg:right-6 lg:bottom-2 xl:right-6 xl:bottom-2 2xl:right-6 2xl:bottom-2 transition-opacity duration-300 ${
        isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      aria-label="Scroll to top"
    >
      <Arrow direction="up" fill="#1E1E1E" />
    </button>
  );
}
